var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var NavigationArrow = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("path", { d: "M3.50629 4.46251L9.00004 20.3344C9.23442 21.0188 10.2094 21 10.425 20.3063L12.6375 13.125C12.6709 13.0076 12.7343 12.9009 12.8214 12.8155C12.9085 12.73 13.0164 12.6687 13.1344 12.6375L20.3063 10.425C21 10.2094 21.0188 9.23439 20.3344 9.00001L4.46254 3.50626C4.32919 3.4594 4.1853 3.45117 4.04748 3.48253C3.90965 3.51389 3.78349 3.58356 3.68354 3.68351C3.58359 3.78346 3.51392 3.90962 3.48256 4.04745C3.4512 4.18527 3.45943 4.32916 3.50629 4.46251V4.46251Z", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
});
